const fetchFavouriteStatus = ({ http, params = {} }) => http({
  url: '/saved-offers/my/status',
  params
})
  .then(({ data }) => data)
  .then(({ statuses }) => statuses);

export default fetchFavouriteStatus;
